/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModDocumentTemplate: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M14.5 0C15.3284 0 16 0.671573 16 1.5V10.5C16 11.3284 15.3284 12 14.5 12H13.5V11H14.5C14.7761 11 15 10.7761 15 10.5V1.5C15 1.22386 14.7761 1 14.5 1H7.5C7.22386 1 7 1.22386 7 1.5V1.999L11.5 2C12.2797 2 12.9204 2.59489 12.9931 3.35554L13 3.5V12.5C13 13.3284 12.3284 14 11.5 14H10.5V13H11.5C11.7761 13 12 12.7761 12 12.5V3.5C12 3.22386 11.7761 3 11.5 3H4.5C4.22386 3 4 3.22386 4 3.5V4H9C9.55228 4 10 4.44772 10 5V15C10 15.5523 9.55228 16 9 16H1C0.447715 16 0 15.5523 0 15V5C0 4.44772 0.447715 4 1 4H3V3.5C3 2.7203 3.59489 2.07955 4.35554 2.00687L4.5 2L6 1.999V1.5C6 0.720304 6.59489 0.0795512 7.35554 0.00686646L7.5 0H14.5ZM9 5H1V15H9V5ZM5 13V14H2V13H5ZM8 11V12H2V11H8ZM8 9V10H2V9H8ZM8 7V8H2V7H8Z' />
		</Svg>
	);
};

export { ModDocumentTemplate };
